import apiV2Service from '../api/api-v2.service';
import {handleApiError} from '../errorHandling/handleApiError';
import {toLocalVideoSettings, toRemoteVideoSettings} from './videoSettings.dataConverters';
import {VideoSettings} from './videoSettings.types';

const BASE_PATH = 'VideoSettings';

async function fetchVideoSettings(): Promise<VideoSettings[]> {
  try {
    const {data} = await apiV2Service.executeGetRequest<VideoSettings[]>(`${BASE_PATH}`);

    return data.map(toLocalVideoSettings);
  } catch (error) {
    handleApiError(error, true);
  }
}

async function addVideoSettings(videoSettings: Partial<VideoSettings>): Promise<number> {
  try {
    const convertedVideoSettings = toRemoteVideoSettings(videoSettings);
    const {data} = await apiV2Service.executePutRequest<number>(
      `${BASE_PATH}`,
      {},
      convertedVideoSettings,
    );

    return data;
  } catch (error) {
    handleApiError(error, true);
  }
}

async function updateVideoSettings(videoSettings: Partial<VideoSettings>): Promise<void> {
  try {
    const convertedVideoSettings = toRemoteVideoSettings(videoSettings);
    await apiV2Service.executePutRequest<void>(
      `${BASE_PATH}/${videoSettings.id}`,
      {},
      convertedVideoSettings,
    );
  } catch (error) {
    handleApiError(error, true);
  }
}

async function deleteVideoSettings(id: number): Promise<void> {
  try {
    await apiV2Service.executeDeleteRequest<void>(`${BASE_PATH}/${id}`);
  } catch (error) {
    handleApiError(error, true);
  }
}

export default {
  fetchVideoSettings,
  addVideoSettings,
  updateVideoSettings,
  deleteVideoSettings,
};
